import styled from "styled-components";
import { ClientSelectionItem } from "../../components-v2/ClientSelectionItem";

export const Container = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
`;

export const UserContainer = styled.div`
  margin-top: 1%;
  background-color: white;
  width: 100%;
  height: 70%;
  @media (min-width: 1500px) {
    height: 75%;
  }
  display: flex;
  flex-direction: column;

  .box-form {
    max-width: 400px;
  }

  .flex {
    form {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

  .gap {
    display: flex;
    flex-direction: row;
    gap: 30px;
  }
  .select-item {
    width: 350px;
    margin-right: 16px;
    position: relative;

    &.card {
      width: 200px;
    }

    .error {
      font-size: 12px;
      color: red;
      position: absolute;
      top: 0;
      right: 0;
    }

    .error-id {
      .ant-select-selector {
        border: 1px solid red;
      }
    }
  }

  .btn-pay {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }

  .select-date {
    & + div {
      margin-left: 16px;
    }
  }

  .select-btn {
    padding-top: 21px;
  }

  .select-table {
    margin-top: 4rem;
  }
`;

export const ModalRow = styled.div`
  display: flex;
`;

export const CustomClientSelectionItem = styled(ClientSelectionItem)`
  margin: 0;
  width: 100%;
  max-height: none;
`;

export const ClientSelectionWrapper = styled.div`
  margin-top: 16px;
  width: 100%;
  max-width: 400px;
  > h3 {
    font-weight: 600;
  }
`;

export const ClientSelectionItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const WrapperSelectBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  span {
    margin-left: 10px;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 17px;
  margin-bottom: 2px;
  border-top: 1px solid #ccc;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  button + button {
    margin-left: 8px;
  }
  button {
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
    border-radius: 2px;
    width: 113px;
    height: 40px;
    margin-bottom: 0px;
    margin-top: 15px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    color: #272d3b;
  }
  .button-confirm {
    border: 1px solid #5188f4;
    background: #5188f4;
    color: #ffffff;
    padding-top: 6px;
  }
  .button-confirm:disabled {
    color: rgba(0, 0, 0, 0.25);
    background: #f5f5f5;
    border: 1px solid #ccc;
    opacity: 0.5;
  }
`;

export const ContainerEditLaunchParameters = styled.div`
  width: 600px;
`;
